import { useMutation } from '@tanstack/react-query';
import { createInvMgmtTransaction } from '../../api/production-request-api/index.js';

/**
 * Hook containing mutation function for creating an Inventory Management transaction.
 */
export const useCreateInvMgmtTransaction = () =>
  useMutation({
    /**
     * mutateFn - Function to call the createInvMgmtTransaction api.
     * Wraps the call so only `input` is forwarded; react-query passes a second
     * mutation-context argument to mutationFn that the API layer must not receive.
     * @param {Local.CreateInvMgmtTransactionInput} input - The inputs for the Inventory Management transaction.
     */
    mutationFn: (input) => createInvMgmtTransaction(input),
  });
